import { Tab } from 'react-bootstrap';
import imageLogo from "../../styles/webroot/images/login_bg.svg";
import EmailUser from './EmailUser';
import { useState } from 'react';
import logo from "../../styles/webroot/images/logo.svg"



function Login() {
    const [showCaptcha, setShowCaptcha] = useState(0);
    // eslint-disable-next-line
    const [showMobileLinks, setShowMobileLinks] = useState(true);
    // eslint-disable-next-line
    const [showEmailLinks, setShowEmailLinks] = useState(true);
    const [showText, setShowText] = useState(false);

    // eslint-disable-next-line
    const activeTabHandler = (selectedtab) => {
        setShowCaptcha((prev)=>prev+1);
    }
    
    return (
        <div className="container-fluid">
            <div className="row">
                <div className='login-image-bg'>
                <div className="login-outer">
                    <div className="login-left-panel">
                        <div className="login-bg">
                            <div className="login-txt">
                                <span>Welcome.</span>
                                <h1> Please sign in to Collection Box</h1>
                            </div>
                            <img src={imageLogo} className="login-bg-img" alt='logo-bg' />
                        </div>
                    </div>
                    <div className="login-right-panel">
                        <div className="logo-img t-centre">
                            <img src={logo} className="" alt='logo' />
                        </div>
                        <div className="login-heading m-md-t">
                            {
                                showText ?
                                    <h2>Verify Otp</h2>
                                    :
                                    <h2>Sign In</h2>
                            }

                        </div>
                        <div className="p-lg-t t-center">
                            {
                                showText ?
                                    <label>Enter your otp to access your account</label>
                                    :
                                    <label>Enter your credential to access your account</label>
                            }

                        </div>
                        <Tab.Container id="" defaultActiveKey="first">
                            <div className="login-tab">

                                <Tab.Content>
                                    <Tab.Pane eventKey="first">
                                        <EmailUser setShowEmailLinks={setShowEmailLinks} setShowMobileLinks={setShowMobileLinks} showCaptcha={showCaptcha} setShowText= {setShowText}/>
                                    </Tab.Pane>
                                </Tab.Content>
                            </div>
                        </Tab.Container>
                    </div>
                </div>
                </div>
            </div>
        </div>
    )
}

export default Login